import React, { useEffect, useState } from 'react'
import styles from './login.module.scss'

import { Link, useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string'

import logo from 'assets/img/logo.png'
import { ACTION, ROUTES, VERSION_APP } from 'consts'
import { decodeJWT } from 'utils'
import { useDispatch, useSelector } from 'react-redux'

//antd
import { Form, Input, Button, Checkbox, notification, Row } from 'antd'

//icons antd
import { UserOutlined, LockOutlined, GoogleOutlined, SafetyOutlined, BankOutlined } from '@ant-design/icons'

//apis
import { login, register, getRecoveryCode } from 'apis/auth'

export default function Login(props) {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [form] = Form.useForm()

  const settingApp = useSelector((state) => state.setting)
  const [status, setStatus] = useState(1)
  const [isProcessingOAuth, setIsProcessingOAuth] = useState(false)

  const params = queryString.parse(location.search)

  const onClickStatus = (data) => setStatus(data)

  const onFinish = async (values) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      var objectLogin = {
        username: values.emailLogin,
        password: values.passwordLogin,
      }
      const res = await login(objectLogin)
      console.log(res)
      if (res.status === 200) {
        if (res.data.mess) notification.error({ message: res.data.mess })
        else {
          // decode thông tin user
          const payload = decodeJWT(res.data.accessToken)
          //Nếu tài khoản user đã xác thực rồi thì
          //vào giao diện chính
          if (payload && payload.is_active) {
            dispatch({ type: ACTION.LOGIN, data: res.data })
            navigate(ROUTES.DASHBOARD)
            notification.success({ message: 'Login success' })
          }
          //Nếu user tồn tại nhưng chưa được xác
          //thực thì sẽ qua giao diện
          //xác thực với thông tin user được truyền kèm
          else {
            await getRecoveryCode(payload && payload.username) //send otp vao email
            navigate(ROUTES.MAIL, {
              state: payload && {
                ...payload,
                passwordLogin: values.passwordLogin,
              },
            })
            notification.warning({ message: 'Please authentication otp!' })
          }
        }
      } else {
        notification.error({
          message: 'Error',
          description:
            res.data.message ||
            'Login failed, wrong username or password, please try again!',
        })
      }
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const onFinishRegister = async () => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const registers = form.getFieldValue()
      const body = {
        ...registers,
        phone: '',
        birthday: '',
        address: '',
        role: 'Seller', //Mặc định khi tạo là role seller
        displayName: '',
        permissions: [],
      }
      console.log(body)
      const res = await register(body)
      console.log(res)
      //Khi đăng kí thành công thì cho qua giao diện xác thực otp
      //đồng thời truyền kèm thêm data đc trả về (data của user vừa được đăng kí)
      //khi request api register
      if (res.status === 200) {
        navigate(ROUTES.MAIL, {
          state: { ...res.data, passwordLogin: body.password },
        })
        notification.success({ message: 'Register success' })
      } else {
        if (res.data.message)
          notification.error({
            message: 'Error',
            description: res.data.message,
          })
        else
          notification.error({
            message: 'Error',
            description: 'Register failed, please try again!',
          })
      }

      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  // Handle Larksuite OAuth login - Multi-company support
  const handleLarksuiteLogin = (company) => {
    // Redirect to backend Larksuite OAuth endpoint with company parameter
    window.location.href = `/api/main/auth/larksuite?company=${company}`
  }

  // Force clear old localStorage if JWT missing balance field
  useEffect(() => {
    try {
      const persistRoot = localStorage.getItem('persist:root')
      if (persistRoot) {
        const parsed = JSON.parse(persistRoot)
        if (parsed.login) {
          const loginData = JSON.parse(parsed.login)
          const token = loginData.accessToken

          if (token) {
            const payload = decodeJWT(token)
            // Check if JWT is missing balance field (old token)
            if (payload && !payload.balance) {
              console.log('🔄 Detected old JWT without balance field, clearing localStorage...')
              localStorage.clear()
              sessionStorage.clear()
              notification.info({
                message: 'Session Updated',
                description: 'Please login again to get the latest features.',
                duration: 3
              })
            }
          }
        }
      }
    } catch (e) {
      console.error('Error checking localStorage:', e)
    }
  }, [])

  // Handle OAuth callback with token in URL or localStorage
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    let token = urlParams.get('token')
    let refreshToken = urlParams.get('refreshToken')
    let provider = urlParams.get('provider')
    let company = urlParams.get('company')
    const error = urlParams.get('error')
    const authSuccess = urlParams.get('auth')

    if (error) {
      notification.error({
        message: 'Login failed',
        description: `Larksuite OAuth error: ${error}`,
      })
      // Remove error from URL
      window.history.replaceState({}, document.title, window.location.pathname)
      return
    }

    // Check localStorage if auth=success (new method for large tokens)
    if (authSuccess === 'success' && !token) {
      // Hide OAuth buttons immediately to prevent double login
      setIsProcessingOAuth(true)

      token = localStorage.getItem('token')
      refreshToken = localStorage.getItem('refreshToken')
      provider = localStorage.getItem('provider')
      company = localStorage.getItem('company')

      // Clear temporary localStorage items after reading
      if (token) {
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('provider')
        localStorage.removeItem('company')
      }
    }

    if (token && provider === 'larksuite') {
      dispatch({ type: ACTION.LOADING, data: true })

      // Decode JWT to get user info
      const payload = decodeJWT(token)

      if (payload && payload.is_active) {
        // Store tokens
        const authData = {
          accessToken: token,
          refreshToken: refreshToken,
          username: payload.username,
          permission: payload.permission,
          role: payload.role,
          larksuite_company: company, // Store company info
        }

        // Dispatch login action
        dispatch({ type: ACTION.LOGIN, data: authData })

        // Redirect to dashboard
        navigate(ROUTES.DASHBOARD)

        const companyName = company === 'ecomholic' ? 'Ecomholic 🏢' : 'ECH-Backend 🏭'
        notification.success({
          message: 'Login successful',
          description: `Welcome ${payload.username}! Logged in via Larksuite (${companyName}).`,
        })
      } else {
        notification.error({
          message: 'Account not active',
          description: 'Please contact admin to activate your account.',
        })
      }

      dispatch({ type: ACTION.LOADING, data: false })

      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname)
    }
  }, [])

  useEffect(() => {
    if (params && Object.keys(params).length) {
      // Skip auto-login if coming from OAuth (auth=success parameter)
      if (params.auth === 'success') {
        return
      }
      if (params.state == 'bamboo') {
        window.open('https://bamboolife.info/install?code=' + params.code)
        return
      }
      onFinish({ emailLogin: params.username, passwordLogin: params.password })
    }
  }, [])

  useEffect(() => {
    form.resetFields()
  }, [status])

  return (
    <div className={styles['login']}>
      <div className={styles['login_img_parent']}>
        {settingApp.link_logo ? (
          <img
            className={styles['login_img']}
            src={settingApp.link_logo}
            alt=""
          />
        ) : Object.keys(settingApp).length > 0 ? (
          <img
            className={styles['login_img']}
            src={logo}
            alt=""
          />
        ) : null}
      </div>
      <div className={styles['login_choose_parent']}>
        <div className={styles['login_choose']}>
          <div
            onClick={() => onClickStatus(1)}
            className={
              status === 1
                ? styles['login_choose_status_active']
                : styles['login_choose_status']
            }>
            Login
          </div>
          <div
            className={
              status === 2
                ? styles['login_choose_status_active']
                : styles['login_choose_status']
            }
            onClick={() => onClickStatus(2)}>
            Register
          </div>
        </div>
      </div>
      {status === 1 ? (
        <Form
          className={styles['login_bottom']}
          form={form}
          onFinish={onFinish}>
          <Form.Item
            className={styles['login_bottom_email']}
            name="emailLogin"
            rules={[
              { required: true, message: 'Please input your username!' },
            ]}>
            <Input
              size="large"
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            className={styles['login_bottom_password']}
            name="passwordLogin"
            rules={[
              { required: true, message: 'Please input your password!' },
            ]}>
            <Input.Password
              size="large"
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Password"
            />
          </Form.Item>
          <div className={styles['login_bottom_left']}>
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox className={styles['login_bottom_left_checkbox']}>
                Remember me
              </Checkbox>
            </Form.Item>
            <Link to={ROUTES.FORGOT_PASSWORD}>
              <div className={styles['login_bottom_left_forgot_password']}>
                Forgot password?
              </div>
            </Link>
          </div>
          <div className={styles['login_bottom_left_button_parent']}>
            <Form.Item>
              <Button
                className={styles['login_bottom_left_button']}
                type="primary"
                htmlType="submit">
                Login
              </Button>
            </Form.Item>
          </div>

          {/* Larksuite OAuth buttons - Multi-company */}
          {!isProcessingOAuth && (
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <div style={{ marginBottom: 8, color: '#666', fontSize: 13 }}>
                Or login with Larksuite:
              </div>

              {/* Ecomholic Button */}
              <Form.Item style={{ marginBottom: 8 }}>
                <Button
                  size="large"
                  icon={<BankOutlined />}
                  onClick={() => handleLarksuiteLogin('ecomholic')}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #4285f4 0%, #5a95f5 100%)',
                    color: 'white',
                    border: 'none',
                    fontWeight: 600,
                    height: 45,
                    boxShadow: '0 2px 8px rgba(66, 133, 244, 0.3)',
                  }}>
                  🏢 Login with Larksuite (Ecomholic)
                </Button>
              </Form.Item>

              {/* ECH-Backend Button */}
              <Form.Item>
                <Button
                  size="large"
                  icon={<SafetyOutlined />}
                  onClick={() => handleLarksuiteLogin('ech_backend')}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #34a853 0%, #46ba64 100%)',
                    color: 'white',
                    border: 'none',
                    fontWeight: 600,
                    height: 45,
                    boxShadow: '0 2px 8px rgba(52, 168, 83, 0.3)',
                  }}>
                  🏭 Login with Larksuite (ECH-Backend)
                </Button>
              </Form.Item>
            </div>
          )}
        </Form>
      ) : (
        <Form
          className={styles['login_bottom']}
          form={form}
          onFinish={onFinishRegister}>
          <Form.Item
            className={styles['login_bottom_email']}
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
            style={{ marginBottom: 24 }}>
            <Input
              size="large"
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            className={styles['login_bottom_password']}
            name="password"
            rules={[
              { required: true, message: 'Please input your password!' },
            ]}>
            <Input.Password
              size="large"
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item
            className={styles['login_bottom_email']}
            name="mail"
            rules={[
              {
                type: 'email',
                required: true,
                message: 'Please input or correct format email!',
              },
            ]}>
            <Input
              size="large"
              prefix={<GoogleOutlined className="site-form-item-icon" />}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            className={styles['login_bottom_email']}
            name="first_name"
            rules={[
              { required: true, message: 'Please input your first name!' },
            ]}>
            <Input
              size="large"
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="First name"
            />
          </Form.Item>
          <Form.Item
            className={styles['login_bottom_email']}
            name="last_name"
            rules={[
              { required: true, message: 'Please input your last name!' },
            ]}>
            <Input
              size="large"
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Last name"
            />
          </Form.Item>
          <div
            style={{ zIndex: '999' }}
            className={styles['login_bottom_left_button_parent']}>
            <Form.Item>
              <Button
                className={styles['login_bottom_left_button']}
                type="primary"
                htmlType="submit">
                Create Account
              </Button>
            </Form.Item>
          </div>
        </Form>
      )}
      {status === 1 ? (
        <div className={styles['copyright']}>
          <div>
            <div>Copyright © 2021 Vie. All rights reserved.</div>
            <Row justify="center">Version: {VERSION_APP}</Row>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}
